<script>
export default {
  name: 'Tag',
  props: {
    color: Object,
    text: String,
    dark: Boolean,
  },
};
</script>

<template>
  <div :class="{tag: true, tag_dark: dark}" v-bind:style="{
    color: color && color.text,
    backgroundColor: color && color.background
  }">
    {{text}}
  </div>
</template>

<style scoped>
  .tag {
    padding: 8px 16px;
    font-size: var(--font-size-xs);
  }

  .tag_dark {
    backdrop-filter: invert(0.8);
  }
</style>
